<template>
  <card-popup
    :loading="loading"
    :items="notifications"
    :viewMoreLink="!loading"
    :pullToRefresh="$vuetify.breakpoint.mobile"
    :value="value"
    @click:item="({ id }) => navigateTo(`/notifs/${id}`)"
    @click:more="navigateTo('/notifs')"
    @refresh="search"
  >
    <template #title>
      <v-card-title
        class="text-center title font-weight-light
         d-flex flex-nowrap align-center justify-space-between"
        @mouseover="updateVisible = true"
        @mouseleave="updateVisible = false"
      >
        <span class="py-1">{{ $t('components.lastNotificationsPopup.title') }}</span>
        <v-fab-transition>
          <v-btn
            v-show="updateVisible"
            v-if="$vuetify.breakpoint.mdAndUp"
            icon dark color="primary"
            @click.stop="search"
          >
            <v-icon dark>mdi-reload</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-card-title>
    </template>

    <template #item="{ item, idx, on }">
      <v-divider :key="`${idx}-divider`" />

      <v-list-item
        :key="item.id"
        v-on="on"
      >
        <v-list-item-action class="mr-4">
          <v-icon color="primary">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>
          {{ item.subject }}
        </v-list-item-title>
      </v-list-item>
    </template>

  </card-popup>
</template>

<script>
import { mapState } from 'vuex';
import { STATUS as NOTIFICATIONS_STATUS } from '@/store/modules/lastNotifications';
import CardPopup from '@/components/CardPopup.vue';

export default {
  components: {
    CardPopup,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      updateVisible: false,
    };
  },
  computed: {
    ...mapState({
      loading: ({ lastNotifications: { status } }) => status === NOTIFICATIONS_STATUS.LOADING,
      notifications: ({ lastNotifications: { notifications } }) => notifications,
    }),
  },
  methods: {
    navigateTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push({ path });
      }
      // [INFO] we will update visibility for NavbarSection to update the visiblity value
      this.$emit('input', false);
    },
    search() {
      this.$store.dispatch('lastNotifications/list');
    },
  },
  created() {
    this.search();
  },
};
</script>
